import React from 'react';

export function EditSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      <div className="bg-white rounded-md p-6 border border-slate-100">
        <div className="h-4 bg-slate-200 rounded w-1/4 mb-6"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="h-10 bg-slate-50 rounded"></div>
          <div className="h-10 bg-slate-50 rounded"></div>
          <div className="h-10 bg-slate-50 rounded"></div>
          <div className="h-10 bg-slate-50 rounded"></div>
          <div className="h-10 bg-slate-50 rounded"></div>
          <div className="h-10 bg-slate-50 rounded"></div>
        </div>
      </div>
    </div>
  );
}
